<template>
  <g>
  <g>
    <path class="st0" d="M251.07,352.82h-68.6c-1.46,0-2.64-1.18-2.64-2.64v-10.81c0-1.46,1.18-2.64,2.64-2.64h68.6
      c1.46,0,2.64,1.18,2.64,2.64v10.81C253.71,351.64,252.53,352.82,251.07,352.82z"/>
    <path class="st1" d="M228.75,353.25h-24.34c-1.46,0-2.64-1.18-2.64-2.64v-11.23c0-1.46,1.18-2.64,2.64-2.64h24.34
      c1.46,0,2.64,1.18,2.64,2.64v11.23C231.39,352.07,230.21,353.25,228.75,353.25z"/>
    <path class="st2" d="M228.75,354.26h-24.34c-1.46,0-2.64-1.18-2.64-2.64v-6.38h29.62v6.38
      C231.39,353.08,230.21,354.26,228.75,354.26z"/>
  </g>
  <g>
    <g>
      <path class="st0" d="M729.43,352.82h-68.6c-1.46,0-2.64-1.18-2.64-2.64v-10.81c0-1.46,1.18-2.64,2.64-2.64h68.6
        c1.46,0,2.64,1.18,2.64,2.64v10.81C732.07,351.64,730.89,352.82,729.43,352.82z"/>
      <path class="st1" d="M707.31,353.25h-24.34c-1.46,0-2.64-1.18-2.64-2.64v-11.23c0-1.46,1.18-2.64,2.64-2.64h24.34
        c1.46,0,2.64,1.18,2.64,2.64v11.23C709.94,352.07,708.76,353.25,707.31,353.25z"/>
      <path class="st2" d="M707.31,354.26h-24.34c-1.46,0-2.64-1.18-2.64-2.64v-6.38h29.62v6.38
        C709.94,353.08,708.76,354.26,707.31,354.26z"/>
    </g>
    <g>
      <g>
        <path class="st3 tool-border" d="M743.83,342.78H170.5c-3.57,0-6.47-2.9-6.47-6.47V96.74c0-3.57,2.9-6.47,6.47-6.47h573.33
          c3.57,0,6.47,2.9,6.47,6.47v239.58C750.3,339.89,747.4,342.78,743.83,342.78z"/>
          <radialGradient id="SVGID_1_" cx="502.8992" cy="108.7411" r="26.9378" gradientTransform="matrix(0.8684 -0.4958 0.1676 0.2936 47.9438 326.1685)" gradientUnits="userSpaceOnUse">
          <stop  offset="0" style="stop-color:#6E6E6E"/>
          <stop  offset="0.2379" style="stop-color:#707070;stop-opacity:0.7621"/>
          <stop  offset="0.4021" style="stop-color:#7A7A7A;stop-opacity:0.5979"/>
          <stop  offset="0.544" style="stop-color:#898989;stop-opacity:0.456"/>
          <stop  offset="0.6733" style="stop-color:#9F9F9F;stop-opacity:0.3267"/>
          <stop  offset="0.7941" style="stop-color:#BBBBBB;stop-opacity:0.2059"/>
          <stop  offset="0.9069" style="stop-color:#DDDDDD;stop-opacity:0.0931"/>
          <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0"/>
        </radialGradient>
        <path class="st3" d="M479.77,122.39c0,0-6.19-10.92,18.23-23.6c23.88-12.4,28.48-2.86,28.48-2.86L479.77,122.39z"/>
        <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="164.0289" y1="326.9087" x2="255.6306" y2="326.9087">
          <stop  offset="0.0159" style="stop-color:#575757"/>
          <stop  offset="0.0166" style="stop-color:#585858"/>
          <stop  offset="0.0314" style="stop-color:#787878"/>
          <stop  offset="0.0468" style="stop-color:#919191"/>
          <stop  offset="0.0629" style="stop-color:#A2A2A2"/>
          <stop  offset="0.0802" style="stop-color:#ADADAD"/>
          <stop  offset="0.1005" style="stop-color:#B0B0B0"/>
          <stop  offset="0.1146" style="stop-color:#A1A1A1"/>
          <stop  offset="0.1573" style="stop-color:#797979"/>
          <stop  offset="0.1911" style="stop-color:#606060"/>
          <stop  offset="0.2116" style="stop-color:#575757"/>
          <stop  offset="0.4375" style="stop-color:#5A5A5A;stop-opacity:0.6453"/>
          <stop  offset="0.5932" style="stop-color:#636363;stop-opacity:0.4006"/>
          <stop  offset="0.7274" style="stop-color:#727272;stop-opacity:0.1897"/>
          <stop  offset="0.8482" style="stop-color:#878787;stop-opacity:0"/>
        </linearGradient>
        <path class="st3" d="M255.63,342.78h-85.42c-3.41,0-6.18-2.77-6.18-6.18v-25.57h91.6V342.78z"/>
          <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="164.0289" y1="106.154" x2="198.0464" y2="106.154" gradientTransform="matrix(1 0 0 -1 0 225.0213)">
          <stop  offset="0.0159" style="stop-color:#575757"/>
          <stop  offset="0.0166" style="stop-color:#585858"/>
          <stop  offset="0.0314" style="stop-color:#787878"/>
          <stop  offset="0.0468" style="stop-color:#919191"/>
          <stop  offset="0.0629" style="stop-color:#A2A2A2"/>
          <stop  offset="0.0802" style="stop-color:#ADADAD"/>
          <stop  offset="0.1005" style="stop-color:#B0B0B0"/>
          <stop  offset="0.1187" style="stop-color:#A1A1A1"/>
          <stop  offset="0.1735" style="stop-color:#797979"/>
          <stop  offset="0.217" style="stop-color:#606060"/>
          <stop  offset="0.2434" style="stop-color:#575757"/>
          <stop  offset="0.2779" style="stop-color:#595959;stop-opacity:0.9543"/>
          <stop  offset="0.7447" style="stop-color:#7B7B7B;stop-opacity:0.3374"/>
          <stop  offset="1" style="stop-color:#878787;stop-opacity:0"/>
        </linearGradient>
        <path class="st3" d="M198.05,90.27h-27.84c-3.41,0-6.18,2.77-6.18,6.18v51.01h34.02V90.27z"/>
        <path class="st3" d="M164.03,306.99v8.51c0,0,0,6.5,6.5,6.5c6.5,0,39.52,0,39.52,0s7.66-0.54,12.94,3.37l27.96,17.45v-34.68
          L164.03,306.99z"/>
        <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="223.5005" y1="318.3921" x2="217.2627" y2="334.3282">
          <stop  offset="0" style="stop-color:#6E6E6E"/>
          <stop  offset="0.0903" style="stop-color:#717171;stop-opacity:0.9701"/>
          <stop  offset="0.1527" style="stop-color:#7A7A7A;stop-opacity:0.9495"/>
          <stop  offset="0.2064" style="stop-color:#898989;stop-opacity:0.9317"/>
          <stop  offset="0.2439" style="stop-color:#999999;stop-opacity:0.9193"/>
          <stop  offset="0.3362" style="stop-color:#9E9E9E;stop-opacity:0.7597"/>
          <stop  offset="0.4487" style="stop-color:#ADADAD;stop-opacity:0.5651"/>
          <stop  offset="0.5717" style="stop-color:#C6C6C6;stop-opacity:0.3524"/>
          <stop  offset="0.7014" style="stop-color:#E8E8E8;stop-opacity:0.1282"/>
          <stop  offset="0.7755" style="stop-color:#FFFFFF;stop-opacity:0"/>
        </linearGradient>
        <path class="st3" d="M198.05,321.98c0,0,12.8,28.88,42.49,14.33l-17.55-10.95c0,0-5.19-4.32-17.28-3.37H198.05z"/>
      </g>
      <path class="st3" d="M532.43,94.02c-2.89-0.01-6.72,2.38-6.89,2.38l-46.47,26.38h-301.4c0,0-13.63,0.04-13.63,14.13
        c0,12.6,0,170.09,0,170.09H517.2V117.51L532.43,94.02z"/>
    </g>
  </g>
  <path class="st8" d="M532.49,102.56h208.68c1.78,0,3.23,1.45,3.23,3.23v227.77c0,1.78-1.45,3.23-3.23,3.23H523.3
    c-1.78,0-3.23-1.45-3.23-3.23V114.98c0-0.36,0.14-0.71,0.4-0.97l11.06-11.06C531.78,102.7,532.13,102.56,532.49,102.56z"/>
  <g>
    <path class="st9" d="M742.89,290.7h-99.48c-1.1,0-2,0.9-2,2v40.7c0,1.1,0.9,2,2,2h97.48c1.1,0,2-0.9,2-2V290.7z"/>
    <path class="st9" d="M658.6,186H523.18c-1.1,0-2,0.9-2,2v145.4c0,1.1,0.9,2,2,2H656.6c1.1,0,2-0.9,2-2V186z"/>
    <path class="st9" d="M658.59,287.8c0,1.6,1.41,2.91,3.14,2.91l0.01,6.51h-13.53v-16.51h10.38V287.8z"/>
  </g>
  <g>
    <path class="st10" d="M655.48,181.86H524.3c-1.71,0-3.12,1.31-3.12,2.91v7.38H658.6v-7.38
      C658.6,183.17,657.2,181.86,655.48,181.86z"/>
  </g>
  <g class="invalid"> <!--Math FFT-->
    <path class="st11" d="M541.8,245.31h-6.48c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h6.48
      c3.69,0,6.72,3.02,6.72,6.72v0C548.52,242.29,545.49,245.31,541.8,245.31z"/>
    <text transform="matrix(1 0 0 1 533.3743 240.9433)" class="st25 st26 st27">FFT</text>
  </g>
  <g class="invalid"> <!--Math M -->
    <path class="st12" d="M541.8,216.78h-6.48c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h6.48
      c3.69,0,6.72,3.02,6.72,6.72v0C548.52,213.76,545.49,216.78,541.8,216.78z"/>
    <text transform="matrix(1 0 0 1 535.9421 211.8967)" class="st25 st26 st27">M</text>
  </g>
  <g class="invalid"> <!--Ref R-->
    <path class="st15" d="M541.8,277.4h-6.48c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h6.48
      c3.69,0,6.72,3.02,6.72,6.72v0C548.52,274.38,545.49,277.4,541.8,277.4z"/>
    <text transform="matrix(1 0 0 1 536.4754 272.9281)" class="st25 st26 st27">R</text>
  </g>
  <circle class="st13" cx="570.56" cy="210.81" r="11.34"/>
  <circle class="st13" cx="570.56" cy="269.52" r="17.44"/>
  <g>
    <radialGradient id="SVGID_5_" cx="680.1541" cy="315.7978" r="9.1528" gradientUnits="userSpaceOnUse">
      <stop  offset="0" style="stop-color:#000000"/>
      <stop  offset="0.2155" style="stop-color:#040404"/>
      <stop  offset="0.4265" style="stop-color:#100F0F"/>
      <stop  offset="0.6356" style="stop-color:#232323"/>
      <stop  offset="0.8424" style="stop-color:#3F3D3D"/>
      <stop  offset="1" style="stop-color:#595757"/>
    </radialGradient>
    <circle class="st14" cx="680.15" cy="315.8" r="9.15"/>
    <circle class="st15" cx="680.15" cy="315.8" r="4.61"/>
    <circle class="st16" cx="680.15" cy="315.8" r="2.5"/>
    <circle class="st17" cx="680.15" cy="315.8" r="0.79"/>
  </g>
  <g>
    <circle class="st18" cx="631.47" cy="315.8" r="14.17"/>
    <g class="pin">
      <radialGradient id="SVGID_6_" cx="631.4691" cy="315.7978" r="9.1528" gradientUnits="userSpaceOnUse">
        <stop  offset="0" style="stop-color:#000000"/>
        <stop  offset="0.2155" style="stop-color:#040404"/>
        <stop  offset="0.4265" style="stop-color:#100F0F"/>
        <stop  offset="0.6356" style="stop-color:#232323"/>
        <stop  offset="0.8424" style="stop-color:#3F3D3D"/>
        <stop  offset="1" style="stop-color:#595757"/>
      </radialGradient>
      <circle class="st19" cx="631.47" cy="315.8" r="9.15"/>
      <circle :id="pincode+'C2'" @click="onClick(`${pincode}C2`)" class="pin-cover terminal" cx="631.47" cy="315.8" r="4.61"/>
      <!-- <circle class="st16" cx="631.47" cy="315.8" r="2.5"/>
      <circle class="st17" cx="631.47" cy="315.8" r="0.79"/> -->
    </g>
  </g>
  <g>
    <circle class="st13" cx="570.56" cy="315.8" r="14.17"/>
    <g class="pin">
      <radialGradient id="SVGID_7_" cx="570.5606" cy="315.7978" r="9.1528" gradientUnits="userSpaceOnUse">
        <stop  offset="0" style="stop-color:#000000"/>
        <stop  offset="0.2155" style="stop-color:#040404"/>
        <stop  offset="0.4265" style="stop-color:#100F0F"/>
        <stop  offset="0.6356" style="stop-color:#232323"/>
        <stop  offset="0.8424" style="stop-color:#3F3D3D"/>
        <stop  offset="1" style="stop-color:#595757"/>
      </radialGradient>
      <circle class="st20" cx="570.56" cy="315.8" r="9.15"/>
      <circle :id="pincode+'C1'" @click="onClick(`${pincode}C1`)" class="pin-cover terminal" cx="570.56" cy="315.8" r="4.61"/>
      <!--<circle class="st16" cx="570.56" cy="315.8" r="2.5"/>
      <circle class="st17" cx="570.56" cy="315.8" r="0.79"/> -->
    </g>
  </g>
  <rect x="568.23" y="216.61" class="st13" width="4.66" height="42.35"/>
  <path class="st13" d="M575.49,246.69h-9.86c-4.45,0-8.1-3.64-8.1-8.1v0c0-4.45,3.64-8.1,8.1-8.1h9.86c4.45,0,8.1,3.64,8.1,8.1v0
    C583.59,243.05,579.94,246.69,575.49,246.69z"/>
  <path class="st18" d="M636.4,246.69h-9.86c-4.45,0-8.1-3.64-8.1-8.1v0c0-4.45,3.64-8.1,8.1-8.1h9.86c4.45,0,8.1,3.64,8.1,8.1v0
    C644.5,243.05,640.85,246.69,636.4,246.69z"/>
  <rect x="629.14" y="216.61" class="st18" width="4.66" height="42.35"/>
  <g>
    <circle class="st18" cx="631.47" cy="210.81" r="11.34"/>
    <circle class="st18" cx="631.47" cy="269.52" r="17.44"/>
  </g>
  <path class="st21" d="M635.75,244.37h-8.55c-3.18,0-5.78-2.6-5.78-5.78v0c0-3.18,2.6-5.78,5.78-5.78h8.55
    c3.18,0,5.78,2.6,5.78,5.78v0C641.53,241.77,638.92,244.37,635.75,244.37z"/>
  <!-- CH1 Vertical Scale -->
  <g ref="verscale1">
    <circle class="st22" cx="570.56" cy="269.52" r="13.82"/>
    <path class="st1" d="M580.82,275.44L580.82,275.44c0.25-0.43,0.88-0.52,1.41-0.21l1.11,0.64c0.83-1.66,1.34-3.5,1.46-5.45h-1.26
      c-0.39,0-0.72-0.16-0.93-0.39c-0.13-0.14-0.2-0.32-0.2-0.51c0-0.49,0.5-0.89,1.11-0.89h1.28c-0.12-1.95-0.63-3.79-1.45-5.45
      l-1.1,0.64c-0.47,0.27-1.02,0.23-1.31-0.08c-0.05-0.04-0.09-0.09-0.12-0.15c-0.25-0.43-0.01-1.02,0.52-1.33l1.11-0.64
      c-0.53-0.79-1.13-1.52-1.79-2.19c-0.67-0.67-1.4-1.27-2.19-1.79l-0.64,1.11c-0.31,0.53-0.9,0.77-1.33,0.52
      c-0.06-0.03-0.11-0.07-0.15-0.12c-0.31-0.29-0.35-0.84-0.08-1.31l0.64-1.1c-1.66-0.82-3.5-1.33-5.45-1.45v1.28
      c0,0.62-0.4,1.11-0.89,1.11c-0.19,0-0.37-0.08-0.51-0.2c-0.24-0.2-0.39-0.54-0.39-0.93v-1.26c-1.95,0.12-3.79,0.64-5.45,1.47
      l0.63,1.09c0.31,0.53,0.21,1.16-0.21,1.41s-1.02,0.01-1.33-0.52l-0.63-1.09c-1.58,1.05-2.94,2.41-3.99,3.99l1.09,0.63
      c0.53,0.31,0.77,0.9,0.52,1.33c-0.25,0.43-0.88,0.52-1.41,0.21l-1.09-0.63c-0.83,1.66-1.34,3.5-1.46,5.45h1.26
      c0.62,0,1.11,0.4,1.11,0.89s-0.5,0.89-1.11,0.89h-1.27c0.12,1.96,0.63,3.81,1.47,5.48l1.11-0.64c0.53-0.31,1.16-0.21,1.41,0.21
      c0.25,0.43,0.01,1.02-0.52,1.33l-1.11,0.64c0.26,0.39,0.54,0.77,0.84,1.14c0.01,0.01,0.02,0.02,0.03,0.03
      c0.13,0.16,0.27,0.32,0.41,0.47c0.04,0.04,0.08,0.08,0.11,0.12c0.11,0.12,0.23,0.24,0.34,0.36c0.06,0.06,0.12,0.12,0.18,0.18
      c0.1,0.09,0.19,0.19,0.29,0.28c0.08,0.07,0.16,0.15,0.24,0.22c0.08,0.07,0.16,0.14,0.24,0.21c0.1,0.08,0.2,0.17,0.31,0.25
      c0.06,0.05,0.13,0.1,0.19,0.15c0.12,0.09,0.25,0.19,0.37,0.28c0.04,0.03,0.08,0.06,0.13,0.09c0.1,0.07,0.2,0.14,0.31,0.21
      l0.64-1.11c0.31-0.53,0.9-0.77,1.33-0.52l0,0c0.43,0.25,0.52,0.88,0.21,1.41l-0.64,1.1c1.66,0.83,3.51,1.34,5.46,1.45v-1.27
      c0-0.62,0.4-1.11,0.89-1.11c0.49,0,0.89,0.5,0.89,1.11v1.27c1.95-0.12,3.79-0.64,5.45-1.46l-0.64-1.11
      c-0.31-0.53-0.21-1.16,0.21-1.41c0.32-0.19,0.75-0.1,1.06,0.19c0.11,0.09,0.2,0.21,0.28,0.34l0.63,1.09
      c1.58-1.05,2.94-2.41,3.99-3.99l-1.09-0.63c-0.13-0.08-0.25-0.17-0.34-0.28C580.73,276.19,580.64,275.77,580.82,275.44z"/>
    <circle class="st23" cx="570.56" cy="269.52" r="11.09"/>
    <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="570.74" cy="263.28" r="2"/>
  </g>
  <!-- Menu Buttons -->
  <g>
    <path class="st24" d="M512.64,164.06h-14.55c-1.37,0-2.49-1.12-2.49-2.49v-8.17c0-1.37,1.12-2.49,2.49-2.49h14.55
      c1.37,0,2.49,1.12,2.49,2.49v8.17C515.13,162.94,514.01,164.06,512.64,164.06z"/>
    <rect x="471.09" y="156.98" class="st22" width="24.51" height="1"/>
    <path class="st24" d="M512.64,191.12h-14.55c-1.37,0-2.49-1.12-2.49-2.49v-8.17c0-1.37,1.12-2.49,2.49-2.49h14.55
      c1.37,0,2.49,1.12,2.49,2.49v8.17C515.13,190,514.01,191.12,512.64,191.12z"/>
    <rect x="471.09" y="184.05" class="st22" width="24.51" height="1"/>
    <path class="st24" d="M512.64,218.19h-14.55c-1.37,0-2.49-1.12-2.49-2.49v-8.17c0-1.37,1.12-2.49,2.49-2.49h14.55
      c1.37,0,2.49,1.12,2.49,2.49v8.17C515.13,217.07,514.01,218.19,512.64,218.19z"/>
    <rect x="471.09" y="211.11" class="st22" width="24.51" height="1"/>
    <path class="st24" d="M512.64,245.25h-14.55c-1.37,0-2.49-1.12-2.49-2.49v-8.17c0-1.37,1.12-2.49,2.49-2.49h14.55
      c1.37,0,2.49,1.12,2.49,2.49v8.17C515.13,244.13,514.01,245.25,512.64,245.25z"/>
    <rect x="471.09" y="238.18" class="st22" width="24.51" height="1"/>
    <path class="st24" d="M512.64,272.31h-14.55c-1.37,0-2.49-1.12-2.49-2.49v-8.17c0-1.37,1.12-2.49,2.49-2.49h14.55
      c1.37,0,2.49,1.12,2.49,2.49v8.17C515.13,271.19,514.01,272.31,512.64,272.31z"/>
    <rect x="471.09" y="265.24" class="st22" width="24.51" height="1"/>
  </g>
  <!-- Menu on/off -->
  <g class="valid" @click="displayMenu()">
    <circle :class="{'st24': !on, 'light-on': on}" cx="505.37" cy="289.04" r="8.55"/>
  </g>
  <path class="st28" d="M574.84,244.37h-8.55c-3.18,0-5.78-2.6-5.78-5.78v0c0-3.18,2.6-5.78,5.78-5.78h8.55
    c3.18,0,5.78,2.6,5.78,5.78v0C580.62,241.77,578.02,244.37,574.84,244.37z"/>
  <!-- CH1 Vertical Position -->
  <g ref="verpos1">
    <circle class="st22" cx="570.56" cy="210.81" r="8.94"/>
    <path class="st1" d="M576.78,216.15c-0.72-0.42-0.97-1.35-0.56-2.08c0.42-0.72,1.35-0.97,2.08-0.56l1.08,0.62
      c0.39-1.04,0.62-2.16,0.62-3.34s-0.22-2.3-0.62-3.34l-1.08,0.62c-0.72,0.42-1.66,0.17-2.08-0.56c-0.42-0.72-0.17-1.66,0.56-2.08
      l1.09-0.63c-1.43-1.74-3.46-2.95-5.78-3.33v1.25c0,0.84-0.68,1.52-1.52,1.52s-1.52-0.68-1.52-1.52v-1.25
      c-2.32,0.38-4.36,1.59-5.78,3.33l1.09,0.63c0.72,0.42,0.97,1.35,0.56,2.08c-0.42,0.72-1.35,0.97-2.08,0.56l-1.08-0.62
      c-0.39,1.04-0.62,2.16-0.62,3.34s0.22,2.3,0.62,3.34l1.08-0.62c0.72-0.42,1.66-0.17,2.08,0.56c0.42,0.72,0.17,1.66-0.56,2.08
      l-1.09,0.63c1.43,1.74,3.46,2.95,5.78,3.33v-1.25c0-0.84,0.68-1.52,1.52-1.52s1.52,0.68,1.52,1.52v1.25
      c2.32-0.38,4.36-1.59,5.78-3.33L576.78,216.15z"/>
    <circle class="st29" cx="570.56" cy="210.81" r="5.41"/>
    <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="570.74" cy="207.28" r="1"/>
  </g>
  <!-- CH2 Vertical Scale -->
  <g ref="verscale2">
    <circle class="st22" cx="631.47" cy="269.52" r="13.82"/>
    <path class="st1" d="M641.73,275.44L641.73,275.44c0.25-0.43,0.88-0.52,1.41-0.21l1.11,0.64c0.83-1.66,1.34-3.5,1.46-5.45h-1.26
      c-0.39,0-0.73-0.16-0.93-0.39c-0.13-0.14-0.2-0.32-0.2-0.51c0-0.49,0.5-0.89,1.11-0.89h1.28c-0.12-1.95-0.63-3.79-1.45-5.45
      l-1.1,0.64c-0.47,0.27-1.02,0.23-1.31-0.08c-0.05-0.04-0.09-0.09-0.12-0.15c-0.25-0.43-0.01-1.02,0.52-1.33l1.11-0.64
      c-0.53-0.79-1.13-1.52-1.79-2.19c-0.67-0.67-1.4-1.27-2.19-1.79l-0.64,1.11c-0.31,0.53-0.9,0.77-1.33,0.52
      c-0.06-0.03-0.11-0.07-0.15-0.12c-0.31-0.29-0.35-0.84-0.08-1.31l0.64-1.1c-1.66-0.82-3.5-1.33-5.45-1.45v1.28
      c0,0.62-0.4,1.11-0.89,1.11c-0.19,0-0.37-0.08-0.51-0.2c-0.24-0.2-0.39-0.54-0.39-0.93v-1.26c-1.95,0.12-3.79,0.64-5.45,1.47
      l0.63,1.09c0.31,0.53,0.21,1.16-0.21,1.41c-0.43,0.25-1.02,0.01-1.33-0.52l-0.63-1.09c-1.58,1.05-2.94,2.41-3.99,3.99l1.09,0.63
      c0.53,0.31,0.77,0.9,0.52,1.33s-0.88,0.52-1.41,0.21l-1.09-0.63c-0.83,1.66-1.34,3.5-1.46,5.45h1.26c0.62,0,1.11,0.4,1.11,0.89
      s-0.5,0.89-1.11,0.89h-1.27c0.12,1.96,0.63,3.81,1.47,5.48l1.11-0.64c0.53-0.31,1.16-0.21,1.41,0.21
      c0.25,0.43,0.01,1.02-0.52,1.33l-1.11,0.64c0.26,0.39,0.54,0.77,0.84,1.14c0.01,0.01,0.02,0.02,0.03,0.03
      c0.13,0.16,0.27,0.32,0.41,0.47c0.04,0.04,0.08,0.08,0.11,0.12c0.11,0.12,0.23,0.24,0.34,0.36c0.06,0.06,0.12,0.12,0.18,0.18
      c0.1,0.09,0.19,0.19,0.29,0.28c0.08,0.07,0.16,0.15,0.24,0.22c0.08,0.07,0.16,0.14,0.24,0.21c0.1,0.08,0.2,0.17,0.31,0.25
      c0.06,0.05,0.13,0.1,0.19,0.15c0.12,0.09,0.25,0.19,0.37,0.28c0.04,0.03,0.08,0.06,0.13,0.09c0.1,0.07,0.2,0.14,0.31,0.21
      l0.64-1.11c0.31-0.53,0.9-0.77,1.33-0.52h0c0.43,0.25,0.52,0.88,0.21,1.41l-0.64,1.1c1.66,0.83,3.51,1.34,5.46,1.45v-1.27
      c0-0.62,0.4-1.11,0.89-1.11s0.89,0.5,0.89,1.11v1.27c1.95-0.12,3.79-0.64,5.45-1.46l-0.64-1.11c-0.31-0.53-0.21-1.16,0.21-1.41
      c0.32-0.19,0.75-0.1,1.06,0.19c0.11,0.09,0.2,0.21,0.28,0.34l0.63,1.09c1.58-1.05,2.94-2.41,3.99-3.99l-1.09-0.63
      c-0.13-0.08-0.25-0.17-0.34-0.28C641.64,276.19,641.54,275.77,641.73,275.44z"/>
    <circle class="st23" cx="631.47" cy="269.52" r="11.09"/>
    <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="631.74" cy="263.28" r="2"/>
  </g>
  <!-- CH2 Vertical Position -->
  <g ref="verpos2">
    <circle class="st22" cx="631.47" cy="210.81" r="8.94"/>
    <path class="st1" d="M637.69,216.15c-0.72-0.42-0.97-1.35-0.56-2.08c0.42-0.72,1.35-0.97,2.08-0.56l1.08,0.62
      c0.39-1.04,0.62-2.16,0.62-3.34s-0.22-2.3-0.62-3.34l-1.08,0.62c-0.72,0.42-1.66,0.17-2.08-0.56c-0.42-0.72-0.17-1.66,0.56-2.08
      l1.09-0.63c-1.43-1.74-3.46-2.95-5.78-3.33v1.25c0,0.84-0.68,1.52-1.52,1.52s-1.52-0.68-1.52-1.52v-1.25
      c-2.32,0.38-4.36,1.59-5.78,3.33l1.09,0.63c0.72,0.42,0.97,1.35,0.56,2.08c-0.42,0.72-1.35,0.97-2.08,0.56l-1.08-0.62
      c-0.39,1.04-0.62,2.16-0.62,3.34s0.22,2.3,0.62,3.34l1.08-0.62c0.72-0.42,1.66-0.17,2.08,0.56c0.42,0.72,0.17,1.66-0.56,2.08
      l-1.09,0.63c1.43,1.74,3.46,2.95,5.78,3.33v-1.25c0-0.84,0.68-1.52,1.52-1.52s1.52,0.68,1.52,1.52v1.25
      c2.32-0.38,4.36-1.59,5.78-3.33L637.69,216.15z"/>
    <circle class="st29" cx="631.47" cy="210.81" r="5.41"/>
    <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="631.74" cy="207.28" r="1"/>
  </g>
  <text transform="matrix(1 0 0 1 629.8656 240.537)" class="st26 st27">2</text>
  <g>
    <text transform="matrix(0.95 0 0 1 590.6959 212.8969)" class="st30 st26 st27">Position</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 263.7408 112.1022)" class="st30 st31 st32">TBS 1072B-EDU</text>
  </g>
  <g>
    <text transform="matrix(1.1078 0 0 1 202.6716 111.6969)" class="st33 st34 st32">Tektronix</text>
  </g>
  <g>
    <text transform="matrix(1 0 0 1 347.9807 111.6969)" class="st30 st31 st35">Digital Oscilloscope</text>
  </g>
  <g>
    <text transform="matrix(0.9 0 0 1 542.8246 172.8674)" class="st36 st37 st38">Press to select</text>
  </g>
  <g>
    <text transform="matrix(1 0 0 1 538.5851 114.2771)" class="st39 st26 st27">Multipurpose</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 593.8194 240.5367)" class="st30 st26 st27">Menu</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 668.0846 303.5481)" class="st30 st26 st27">Ext Tring</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 478.2354 287.8802)"><tspan x="0" y="0" class="st40 st26 st27">Menu</tspan><tspan x="-1.39" y="6" class="st40 st26 st27">On/Off</tspan></text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 593.9786 271.2399)" class="st30 st26 st27">Scale</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 579.012 189.3101)" class="st41 st26 st27">Vertical</text>
  </g>
  <text transform="matrix(1 0 0 1 568.9567 240.537)" class="st26 st27">1</text>
  <rect x="721.93" y="303.91" class="st42" width="2.07" height="9.54"/>
  <rect x="721.93" y="316.74" class="st42" width="2.07" height="9.54"/>
  <g>
    <!-- Cursor -->
    <g class="valid">
      <path :class="{'st40': !on, 'light-on': on }" d="M615.86,125.34h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
        c3.69,0,6.72,3.02,6.72,6.72v0C622.58,122.31,619.56,125.34,615.86,125.34z"/>
        <text transform="matrix(1 0 0 1 598.3684 120.8136)" class="st30 st26 st27">Cursor</text>
    </g>
    <g>
      <!-- Zoom Button -->
      <g class="valid" @click="setMainMenu('zoom')">
        <path :class="{'st40': !on, 'light-on': on }" d="M615.86,150h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72v0C622.58,146.98,619.56,150,615.86,150z"/>
      </g>
    </g>
    <g class="invalid">
      <path class="st42" d="M615.86,172.42h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
        c3.69,0,6.72,3.02,6.72,6.72v0C622.58,169.4,619.56,172.42,615.86,172.42z"/>
      <text transform="matrix(1 0 0 1 597.8345 167.5456)" class="st41 st26 st27">Course</text>
    </g>
    <g>
      <path class="st30" d="M610.54,147.69l-0.74,0.33c-0.29,0.13-0.62-0.02-0.72-0.32l-1.2-3.56l1-0.45l1.9,3.24
        C610.95,147.21,610.83,147.56,610.54,147.69z"/>
      <circle class="st43" cx="607.56" cy="141.96" r="2.46"/>
    </g>
  </g>
  <g>
    <g class="invalid">
      <path class="st40" d="M652.6,125.34h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
        c3.69,0,6.72,3.02,6.72,6.72v0C659.32,122.31,656.3,125.34,652.6,125.34z"/>
      <text transform="matrix(0.95 0 0 1 633.5782 120.8136)" class="st30 st26 st27">Measure</text>
    </g>
    <g>
      <g>
        <path class="st40" d="M652.6,150h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72v0C659.32,146.98,656.3,150,652.6,150z"/>
      </g>
      <text transform="matrix(0.95 0 0 1 638.3807 142.8591)"><tspan x="0" y="0" class="st30 st26 st27">Save</tspan><tspan x="-1.74" y="4.5" class="st30 st26 st27">Recall</tspan></text>
    </g>
    <g class="invalid">
      <path class="st42" d="M652.6,172.42h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
        c3.69,0,6.72,3.02,6.72,6.72v0C659.32,169.4,656.3,172.42,652.6,172.42z"/>
      <text transform="matrix(0.95 0 0 1 633.532 167.546)" class="st41 st26 st27">Function</text>
    </g>
  </g>
  <path class="st9" d="M661.38,285.78c0,1.6,1.41,2.91,3.14,2.91h33.08c1.73,0,3.14-1.31,3.14-2.91v-96.64h-39.36V285.78z"/>
  <path class="st10" d="M697.6,181.86h-33.08c-1.73,0-3.14,1.31-3.14,2.91v7.38h39.36v-7.38
    C700.74,183.17,699.32,181.86,697.6,181.86z"/>
  <!-- Horizontal Scale -->
  <g ref="hoscale">
    <circle class="st22" cx="681.06" cy="269.91" r="13.82"/>
    <path class="st1" d="M691.32,275.83L691.32,275.83c0.25-0.43,0.88-0.52,1.41-0.21l1.11,0.64c0.83-1.66,1.34-3.5,1.46-5.45h-1.26
      c-0.39,0-0.72-0.16-0.93-0.39c-0.13-0.14-0.2-0.32-0.2-0.51c0-0.49,0.5-0.89,1.11-0.89h1.28c-0.12-1.95-0.63-3.79-1.45-5.45
      l-1.1,0.64c-0.47,0.27-1.02,0.23-1.31-0.08c-0.05-0.04-0.09-0.09-0.12-0.15c-0.25-0.43-0.01-1.02,0.52-1.33l1.11-0.64
      c-0.53-0.79-1.13-1.52-1.79-2.19c-0.67-0.67-1.4-1.27-2.19-1.79l-0.64,1.11c-0.31,0.53-0.9,0.77-1.33,0.52
      c-0.06-0.03-0.11-0.07-0.15-0.12c-0.31-0.29-0.35-0.84-0.08-1.31l0.64-1.1c-1.66-0.82-3.5-1.33-5.45-1.45v1.28
      c0,0.62-0.4,1.11-0.89,1.11c-0.19,0-0.37-0.08-0.51-0.2c-0.24-0.2-0.39-0.54-0.39-0.93v-1.26c-1.95,0.12-3.79,0.64-5.45,1.47
      l0.63,1.09c0.31,0.53,0.21,1.16-0.21,1.41s-1.02,0.01-1.33-0.52l-0.63-1.09c-1.58,1.05-2.94,2.41-3.99,3.99l1.09,0.63
      c0.53,0.31,0.77,0.9,0.52,1.33s-0.88,0.52-1.41,0.21l-1.09-0.63c-0.83,1.66-1.34,3.5-1.46,5.45h1.26c0.62,0,1.11,0.4,1.11,0.89
      c0,0.49-0.5,0.89-1.11,0.89h-1.27c0.12,1.96,0.63,3.81,1.47,5.48l1.11-0.64c0.53-0.31,1.16-0.21,1.41,0.21
      c0.25,0.43,0.01,1.02-0.52,1.33l-1.11,0.64c0.26,0.39,0.54,0.77,0.84,1.14c0.01,0.01,0.02,0.02,0.03,0.03
      c0.13,0.16,0.27,0.32,0.41,0.47c0.04,0.04,0.08,0.08,0.11,0.12c0.11,0.12,0.23,0.24,0.34,0.36c0.06,0.06,0.12,0.12,0.18,0.18
      c0.1,0.09,0.19,0.19,0.29,0.28c0.08,0.07,0.16,0.15,0.24,0.22c0.08,0.07,0.16,0.14,0.24,0.21c0.1,0.08,0.2,0.17,0.31,0.25
      c0.06,0.05,0.13,0.1,0.19,0.15c0.12,0.09,0.25,0.19,0.37,0.28c0.04,0.03,0.08,0.06,0.13,0.09c0.1,0.07,0.2,0.14,0.31,0.21
      l0.64-1.11c0.31-0.53,0.9-0.77,1.33-0.52l0,0c0.43,0.25,0.52,0.88,0.21,1.41l-0.64,1.1c1.66,0.83,3.51,1.34,5.46,1.45v-1.27
      c0-0.62,0.4-1.11,0.89-1.11s0.89,0.5,0.89,1.11v1.27c1.95-0.12,3.79-0.64,5.45-1.46l-0.64-1.11c-0.31-0.53-0.21-1.16,0.21-1.41
      c0.32-0.19,0.75-0.1,1.06,0.19c0.11,0.09,0.2,0.21,0.28,0.34l0.63,1.09c1.58-1.05,2.94-2.41,3.99-3.99l-1.09-0.63
      c-0.13-0.08-0.25-0.17-0.34-0.28C691.22,276.57,691.13,276.15,691.32,275.83z"/>
    <circle class="st23" cx="681.06" cy="269.91" r="11.09"/>
    <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="681.74" cy="263.28" r="2"/>
  </g>
  <!-- Horizontal Position -->
  <g ref="hopos">
    <circle class="st22" cx="681.06" cy="213.19" r="8.94"/>
    <path class="st1" d="M687.27,218.54c-0.72-0.42-0.97-1.35-0.56-2.08c0.42-0.72,1.35-0.97,2.08-0.56l1.08,0.62
      c0.39-1.04,0.62-2.16,0.62-3.34s-0.22-2.3-0.62-3.34l-1.08,0.62c-0.72,0.42-1.66,0.17-2.08-0.56c-0.42-0.72-0.17-1.66,0.56-2.08
      l1.09-0.63c-1.43-1.74-3.46-2.95-5.78-3.33v1.25c0,0.84-0.68,1.52-1.52,1.52s-1.52-0.68-1.52-1.52v-1.25
      c-2.32,0.38-4.36,1.59-5.78,3.33l1.09,0.63c0.72,0.42,0.97,1.35,0.56,2.08c-0.42,0.72-1.35,0.97-2.08,0.56l-1.08-0.62
      c-0.39,1.04-0.62,2.16-0.62,3.34s0.22,2.3,0.62,3.34l1.08-0.62c0.72-0.42,1.66-0.17,2.08,0.56c0.42,0.72,0.17,1.66-0.56,2.08
      l-1.09,0.63c1.43,1.74,3.46,2.95,5.78,3.33v-1.25c0-0.84,0.68-1.52,1.52-1.52s1.52,0.68,1.52,1.52v1.25
      c2.32-0.38,4.36-1.59,5.78-3.33L687.27,218.54z"/>
    <circle class="st29" cx="681.06" cy="213.19" r="5.41"/>
    <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="681.74" cy="208.28" r="1"/>
  </g>
  <g>
    <path class="st40" d="M688.83,244.76h-15.54c-3.18,0-5.78-2.6-5.78-5.78l0,0c0-3.18,2.6-5.78,5.78-5.78h15.54
      c3.18,0,5.78,2.6,5.78,5.78l0,0C694.61,242.16,692.01,244.76,688.83,244.76z"/>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 671.3659 240.9221)" class="st30 st26 st27">Acquire</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 674.1285 252.4662)" class="st30 st26 st27">Scale</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 668.163 188.6955)" class="st41 st26 st27">Horizontal</text>
  </g>
  <g>
    <text transform="matrix(0.95 0 0 1 670.8456 200.8913)" class="st36 st26 st27">Position</text>
  </g>
  <g>
    <g>
      <g class="valid">
        <path :class="{'st40': !on, 'light-on': on}" d="M689.34,125.34h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72v0C696.06,122.31,693.04,125.34,689.34,125.34z"/>
        <text transform="matrix(0.95 0 0 1 675.4866 120.8136)" class="st30 st26 st27">Help</text>
      </g>
    </g>
    <g>
      <g class="invalid">
        <path class="st40" d="M689.34,150h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72v0C696.06,146.98,693.04,150,689.34,150z"/>
        <text transform="matrix(0.95 0 0 1 672.2343 142.8589)"><tspan x="0" y="0" class="st30 st26 st27">Default</tspan><tspan x="1.75" y="4.5" class="st30 st26 st27">Setup</tspan></text>
      </g>
    </g>
    <g class="invalid">
      <path class="st40" d="M689.34,172.42h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
        c3.69,0,6.72,3.02,6.72,6.72v0C696.06,169.4,693.04,172.42,689.34,172.42z"/>
      <text transform="matrix(0.95 0 0 1 674.0612 167.546)" class="st30 st26 st27">Utility</text>
    </g>
  </g>
  <g>
    <path class="st9" d="M702.18,189.14v96.64c0,1.6,1.41,2.91,3.14,2.91h33.08c1.73,0,3.14-1.31,3.14-2.91v-96.64H702.18z"/>
    <path class="st10" d="M741.55,184.77c0-1.6-1.41-2.91-3.14-2.91h-33.08c-1.73,0-3.14,1.31-3.14,2.91v7.38h39.36V184.77z"/>
    <g>
      <circle class="st22" cx="721.86" cy="244.71" r="8.94"/>
      <path class="st1" d="M728.08,250.05c-0.72-0.42-0.97-1.35-0.56-2.08c0.42-0.72,1.35-0.97,2.08-0.56l1.08,0.62
        c0.39-1.04,0.62-2.16,0.62-3.34s-0.22-2.3-0.62-3.34L729.6,242c-0.72,0.42-1.66,0.17-2.08-0.56c-0.42-0.72-0.17-1.66,0.56-2.08
        l1.09-0.63c-1.43-1.74-3.46-2.95-5.78-3.33v1.25c0,0.84-0.68,1.52-1.52,1.52s-1.52-0.68-1.52-1.52v-1.25
        c-2.32,0.38-4.36,1.59-5.78,3.33l1.09,0.63c0.72,0.42,0.97,1.35,0.56,2.08c-0.42,0.72-1.35,0.97-2.08,0.56l-1.08-0.62
        c-0.39,1.04-0.62,2.16-0.62,3.34s0.22,2.3,0.62,3.34l1.08-0.62c0.72-0.42,1.66-0.17,2.08,0.56c0.42,0.72,0.17,1.66-0.56,2.08
        l-1.09,0.63c1.43,1.74,3.46,2.95,5.78,3.33v-1.25c0-0.84,0.68-1.52,1.52-1.52s1.52,0.68,1.52,1.52v1.25
        c2.32-0.38,4.36-1.59,5.78-3.33L728.08,250.05z"/>
      <circle class="st29" cx="721.86" cy="244.71" r="5.41"/>
    </g>
    <g>
      <text transform="matrix(0.95 0 0 1 712.765 188.6955)" class="st41 st26 st27">Trigger</text>
    </g>
    <g>
      <text transform="matrix(0.95 0 0 1 713.8704 201.1418)"><tspan x="0" y="0" class="st36 st37 st38">Hold for</tspan><tspan x="-4.89" y="4.5" class="st36 st37 st38">Trigger View</tspan></text>
    </g>
    <g>
      <text transform="matrix(0.95 0 0 1 714.3589 259.9289)" class="st36 st37 st38">Push to</text>
    </g>
    <g>
      <text transform="matrix(0.95 0 0 1 715.2363 231.5465)" class="st30 st26 st27">Level</text>
    </g>
    <g>
      <g>
        <path class="st40" d="M729.63,219.22h-15.54c-3.18,0-5.78-2.6-5.78-5.78l0,0c0-3.18,2.6-5.78,5.78-5.78h15.54
          c3.18,0,5.78,2.6,5.78,5.78l0,0C735.41,216.62,732.81,219.22,729.63,219.22z"/>
      </g>
      <g>
        <text transform="matrix(0.95 0 0 1 714.7762 215.3864)" class="st30 st26 st27">Menu</text>
      </g>
    </g>
    <g>
      <g>
        <path class="st40" d="M729.63,276.47h-15.54c-3.18,0-5.78-2.6-5.78-5.78v0c0-3.18,2.6-5.78,5.78-5.78h15.54
          c3.18,0,5.78,2.6,5.78,5.78v0C735.41,273.86,732.81,276.47,729.63,276.47z"/>
      </g>
      <g>
        <text transform="matrix(0.78 0 0 1 710.2765 272.6285)" class="st30 st26 st27">Force Tring</text>
      </g>
    </g>
    <g>
      <g>
        <!-- Run/Stop Button -->
        <g class="valid" @click="handleTrigger()">
          <path :class="{'st40': !on, 'light-on': on}" d="M729.95,125.34h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
            c3.69,0,6.72,3.02,6.72,6.72v0C736.67,122.31,733.65,125.34,729.95,125.34z"/>
                  <text transform="matrix(0.95 0 0 1 709.9678 120.8136)" class="st30 st26 st27">Run/Stop</text>
        </g>
      </g>
        <!--Singel Button -->
      <g>
        <g class="valid" @click="setMainMenu('single')">
          <path :class="{'st40': !on, 'light-on': on}" d="M729.95,150h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
            c3.69,0,6.72,3.02,6.72,6.72v0C736.67,146.98,733.65,150,729.95,150z"/>
          <text transform="matrix(0.95 0 0 1 714.129 145.4806)" class="st30 st26 st27">Single</text>
        </g>
      </g>
      <g>
        <!-- Autoset -->
        <g class="valid" @click="autoset()">
          <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="721.8643" y1="155.463" x2="721.8643" y2="174.527">
            <stop  offset="0" style="stop-color:#9E9E9F"/>
            <stop  offset="0.227" style="stop-color:#BFC0C0"/>
            <stop  offset="0.4151" style="stop-color:#D4D4D5"/>
            <stop  offset="0.5397" style="stop-color:#DBDCDC"/>
            <stop  offset="0.6453" style="stop-color:#D6D6D7"/>
            <stop  offset="0.7808" style="stop-color:#C6C6C7"/>
            <stop  offset="0.9318" style="stop-color:#ACACAD"/>
            <stop  offset="1" style="stop-color:#9E9E9F"/>
          </linearGradient>
          <path :class="{'st45': !on, 'light-on': on}" d="M729.95,172.04h-16.18c-3.69,0-6.72-3.02-6.72-6.72l0,0c0-3.69,3.02-6.72,6.72-6.72h16.18
            c3.69,0,6.72,3.02,6.72,6.72l0,0C736.67,169.01,733.65,172.04,729.95,172.04z"/>
          <path class="st41" d="M729.6,170.28h-15.47c-2.73,0-4.96-2.23-4.96-4.96l0,0c0-2.73,2.23-4.96,4.96-4.96h15.47
            c2.73,0,4.96,2.23,4.96,4.96l0,0C734.56,168.05,732.33,170.28,729.6,170.28z"/>
          <path :class="{'st40': !on, 'light-on': on}" d="M729.52,169.35h-15.3c-2.21,0-4.03-1.81-4.03-4.03l0,0c0-2.21,1.81-4.03,4.03-4.03h15.3
            c2.21,0,4.03,1.81,4.03,4.03l0,0C733.54,167.53,731.73,169.35,729.52,169.35z"/>
          <text transform="matrix(0.95 0 0 1 713.5466 166.821)" class="st26 st46">Autoset</text>
        </g>
      </g>
    </g>
  </g>
  <text transform="matrix(1 0 0 1 531.5609 201.5058)" class="st25 st26 st27">Math</text>
  <text transform="matrix(1 0 0 1 533.8597 261.7611)" class="st25 st26 st27">Ref</text>
  <g>
    <text transform="matrix(0.9 0 0 1 703.688 177.9738)" class="st36 st37 st38">Hold for Autorange</text>
  </g>
  <g>
    <circle class="st24" cx="506.36" cy="130.24" r="8.55"/>
    <g>
      <polygon class="st47" points="509.36,134.19 502.4,134.19 502.4,126.28 510.32,126.28 510.32,133.03"/>
      <rect x="503.85" y="126.28" class="st47" width="5.01" height="3.51"/>
      <rect x="504.84" y="131.61" class="st47" width="3.03" height="2.59"/>
    </g>
  </g>
  <g>
    <path class="st9" d="M467.41,311.08h-87.59v19.53h87.59c1.82,0,3.3-1.48,3.3-3.3v-12.94
      C470.71,312.55,469.23,311.08,467.41,311.08z"/>
    <path class="st48" d="M266.45,311.08c0,0-3.97-0.41-4.26,3.36c-0.21,2.85,2.85,4.26,2.85,4.26s16.94,9.13,20.11,10.71
      c1.66,0.83,3.22,1.2,5.36,1.2h89.3v-19.53H266.45z"/>
  </g>
  <polyline class="st23" points="531.13,122.1 537.43,122.1 543.05,125.76"/>
  <!-- Multipurpose Button -->
  <g>
    <circle class="st22" cx="556.74" cy="143.28" r="22.78"/>
    <g ref="multi" transform="translate(0,0)">
      <path class="st1" d="M573.65,153.04L573.65,153.04c0.41-0.7,1.45-0.86,2.32-0.35l1.83,1.06c1.36-2.73,2.21-5.77,2.41-8.98h-2.08
        c-0.64,0-1.19-0.26-1.52-0.65c-0.21-0.24-0.34-0.53-0.34-0.84c0-0.81,0.82-1.47,1.84-1.47h2.11c-0.2-3.21-1.04-6.24-2.39-8.97
        l-1.82,1.05c-0.77,0.45-1.67,0.38-2.15-0.13c-0.07-0.07-0.14-0.16-0.2-0.25c-0.41-0.7-0.02-1.68,0.86-2.19l1.83-1.06
        c-0.87-1.3-1.86-2.51-2.96-3.61c-1.1-1.1-2.31-2.09-3.61-2.96l-1.06,1.83c-0.51,0.88-1.49,1.26-2.19,0.86
        c-0.09-0.05-0.18-0.12-0.25-0.2c-0.5-0.48-0.57-1.38-0.13-2.15l1.05-1.82c-2.73-1.36-5.77-2.2-8.97-2.39v2.11
        c0,1.01-0.66,1.84-1.47,1.84c-0.31,0-0.6-0.13-0.84-0.34c-0.39-0.33-0.65-0.89-0.65-1.52v-2.08c-3.21,0.2-6.25,1.05-8.99,2.42
        l1.04,1.8c0.51,0.88,0.35,1.92-0.35,2.32c-0.7,0.41-1.68,0.02-2.19-0.86l-1.04-1.8c-2.61,1.73-4.84,3.97-6.58,6.58l1.8,1.04
        c0.88,0.51,1.26,1.49,0.86,2.19c-0.41,0.7-1.45,0.86-2.32,0.35l-1.8-1.04c-1.36,2.74-2.21,5.77-2.41,8.99h2.08
        c1.01,0,1.84,0.66,1.84,1.47c0,0.81-0.82,1.47-1.84,1.47h-2.09c0.2,3.23,1.05,6.28,2.41,9.03l1.83-1.06
        c0.88-0.51,1.92-0.35,2.32,0.35c0.41,0.7,0.02,1.68-0.86,2.19l-1.83,1.06c0.43,0.65,0.89,1.27,1.39,1.87
        c0.02,0.02,0.03,0.04,0.05,0.05c0.22,0.27,0.44,0.53,0.67,0.78c0.06,0.07,0.13,0.14,0.19,0.2c0.18,0.2,0.37,0.4,0.56,0.59
        c0.1,0.1,0.2,0.2,0.3,0.3c0.16,0.15,0.32,0.31,0.48,0.46c0.13,0.12,0.27,0.24,0.4,0.36c0.13,0.12,0.27,0.23,0.4,0.35
        c0.17,0.14,0.33,0.28,0.5,0.41c0.11,0.08,0.21,0.17,0.32,0.25c0.2,0.16,0.41,0.31,0.62,0.46c0.07,0.05,0.14,0.1,0.21,0.15
        c0.17,0.12,0.34,0.23,0.51,0.34l1.05-1.82c0.51-0.88,1.49-1.26,2.19-0.86h0c0.7,0.41,0.86,1.45,0.35,2.32l-1.05,1.82
        c2.74,1.36,5.78,2.2,9,2.4v-2.09c0-1.01,0.66-1.84,1.47-1.84s1.47,0.82,1.47,1.84v2.09c3.21-0.2,6.25-1.05,8.98-2.41l-1.06-1.83
        c-0.51-0.88-0.35-1.92,0.35-2.32c0.53-0.31,1.23-0.16,1.75,0.32c0.18,0.15,0.33,0.34,0.46,0.56l1.04,1.8
        c2.61-1.73,4.84-3.97,6.58-6.58l-1.8-1.04c-0.22-0.13-0.41-0.29-0.56-0.46C573.49,154.27,573.34,153.57,573.65,153.04z"/>
        <circle class="st23" cx="556.74" cy="143.28" r="18.28"/>
        <circle class="st22" style="stroke: #777; stroke-width: 0.5px;" cx="556.74" cy="133.28" r="3"/>
    </g>
  </g>
  <path class="st33" d="M470.88,117.51h-36.91l15.42-18.72h21.49c2.16,0,3.91,1.75,3.91,3.91v10.89
    C474.79,115.75,473.04,117.51,470.88,117.51z"/>
  <g>
    <rect x="488.32" y="315.46" class="st49" width="22.41" height="9.45"/>
    <rect x="490.63" y="322.7" class="st50" width="17.8" height="2.21"/>
    <g>
      <g>
        <circle class="st40" cx="504.59" cy="329.28" r="0.71"/>
        <circle class="st40" cx="493.91" cy="329.28" r="0.92"/>
        <circle class="st40" cx="501.19" cy="327.97" r="0.71"/>
        <path class="st40" d="M496.27,329.16h-0.25c0-1.04,0.92-1.32,1.4-1.32h3.6v0.25h-3.6C497.37,328.09,496.27,328.11,496.27,329.16
          z"/>
        <g>
          <circle class="st40" cx="502.35" cy="330.62" r="0.71"/>
          <path class="st40" d="M502.18,330.74h-2.6c-0.48,0-1.4-0.28-1.4-1.32h0.25c0,1.05,1.1,1.07,1.15,1.07h2.6V330.74z"/>
        </g>
        <rect x="493.91" y="329.16" class="st40" width="10.68" height="0.25"/>
      </g>
    </g>
  </g>
  <path class="st23" d="M470.88,117.51H193.16c-2.16,0-3.91-1.75-3.91-3.91V102.7c0-2.16,1.75-3.91,3.91-3.91h277.71
    c2.16,0,3.91,1.75,3.91,3.91v10.89C474.79,115.75,473.04,117.51,470.88,117.51z"/>
  <path class="st51" d="M464.93,293.15h-269.9c-3.19,0-5.78-2.59-5.78-5.78V140.32c0-3.19,2.59-5.78,5.78-5.78h269.9
    c3.19,0,5.78,2.59,5.78,5.78v147.05C470.71,290.57,468.12,293.15,464.93,293.15z"/>
  <g>
    <g>
      <g>
        <g>
          <path class="st52" d="M599.7,296.08c0.01,0,0.03,0,0.06,0c0.03,0,0.05,0,0.07,0c0.09,0,0.17-0.01,0.24-0.02
            c0.08-0.02,0.15-0.04,0.21-0.08s0.12-0.08,0.16-0.14c0.04-0.06,0.06-0.14,0.06-0.23c0-0.15-0.05-0.27-0.16-0.36
            s-0.23-0.14-0.37-0.14c-0.18,0-0.32,0.06-0.42,0.18c-0.1,0.12-0.15,0.28-0.15,0.48h-0.72c0.01-0.38,0.14-0.7,0.37-0.93
            c0.23-0.24,0.54-0.36,0.92-0.36c0.15,0,0.3,0.02,0.45,0.07c0.15,0.05,0.28,0.11,0.41,0.2c0.12,0.09,0.22,0.2,0.29,0.33
            s0.11,0.28,0.11,0.44c0,0.18-0.05,0.35-0.14,0.49s-0.22,0.23-0.39,0.28v0.01c0.2,0.05,0.36,0.15,0.48,0.3
            c0.12,0.16,0.18,0.34,0.18,0.55c0,0.19-0.04,0.37-0.11,0.52c-0.07,0.15-0.17,0.28-0.3,0.39c-0.13,0.1-0.28,0.18-0.45,0.24
            c-0.17,0.05-0.34,0.08-0.53,0.08c-0.42,0-0.76-0.12-1.01-0.36c-0.25-0.24-0.38-0.57-0.38-1h0.72c0.01,0.22,0.07,0.39,0.18,0.53
            c0.11,0.14,0.27,0.21,0.48,0.21c0.17,0,0.32-0.05,0.43-0.16c0.12-0.11,0.17-0.25,0.17-0.42c0-0.13-0.03-0.24-0.08-0.31
            s-0.11-0.13-0.19-0.17c-0.08-0.03-0.17-0.06-0.26-0.06c-0.09-0.01-0.21-0.01-0.34-0.01V296.08z"/>
          <path class="st52" d="M601.67,295.52c0.07-0.25,0.17-0.45,0.29-0.6c0.12-0.15,0.27-0.26,0.43-0.33c0.16-0.07,0.34-0.1,0.53-0.1
            c0.2,0,0.38,0.03,0.54,0.1c0.16,0.07,0.31,0.17,0.44,0.33c0.13,0.15,0.22,0.35,0.3,0.6s0.11,0.55,0.11,0.9
            c0,0.36-0.04,0.67-0.11,0.92c-0.07,0.25-0.17,0.46-0.29,0.61c-0.12,0.15-0.27,0.26-0.43,0.33c-0.17,0.07-0.35,0.1-0.54,0.1
            c-0.19,0-0.37-0.03-0.53-0.1c-0.16-0.07-0.31-0.18-0.43-0.33c-0.13-0.15-0.22-0.35-0.29-0.61c-0.07-0.25-0.11-0.56-0.11-0.92
            C601.56,296.07,601.6,295.77,601.67,295.52z M602.33,296.86c0.01,0.13,0.03,0.27,0.07,0.41c0.04,0.14,0.1,0.25,0.18,0.35
            c0.09,0.09,0.2,0.14,0.34,0.14c0.15,0,0.26-0.05,0.35-0.14s0.15-0.21,0.19-0.35c0.04-0.14,0.06-0.28,0.07-0.41
            c0.01-0.13,0.01-0.28,0.01-0.44c0-0.15,0-0.29-0.01-0.42c-0.01-0.13-0.03-0.26-0.07-0.4s-0.1-0.25-0.19-0.34
            c-0.08-0.09-0.2-0.14-0.35-0.14c-0.14,0-0.26,0.04-0.34,0.14c-0.08,0.09-0.15,0.21-0.18,0.34c-0.04,0.14-0.06,0.27-0.07,0.4
            s-0.01,0.27-0.01,0.42C602.32,296.58,602.33,296.73,602.33,296.86z"/>
          <path class="st52" d="M604.64,295.52c0.07-0.25,0.17-0.45,0.29-0.6c0.12-0.15,0.27-0.26,0.43-0.33c0.16-0.07,0.34-0.1,0.53-0.1
            c0.2,0,0.38,0.03,0.54,0.1c0.16,0.07,0.31,0.17,0.44,0.33c0.13,0.15,0.22,0.35,0.3,0.6s0.11,0.55,0.11,0.9
            c0,0.36-0.04,0.67-0.11,0.92c-0.07,0.25-0.17,0.46-0.29,0.61c-0.12,0.15-0.27,0.26-0.43,0.33c-0.17,0.07-0.35,0.1-0.54,0.1
            c-0.19,0-0.37-0.03-0.53-0.1c-0.16-0.07-0.31-0.18-0.43-0.33c-0.13-0.15-0.22-0.35-0.29-0.61c-0.07-0.25-0.11-0.56-0.11-0.92
            C604.53,296.07,604.57,295.77,604.64,295.52z M605.3,296.86c0.01,0.13,0.03,0.27,0.07,0.41c0.04,0.14,0.1,0.25,0.18,0.35
            c0.09,0.09,0.2,0.14,0.34,0.14c0.15,0,0.26-0.05,0.35-0.14s0.15-0.21,0.19-0.35c0.04-0.14,0.06-0.28,0.07-0.41
            c0.01-0.13,0.01-0.28,0.01-0.44c0-0.15,0-0.29-0.01-0.42c-0.01-0.13-0.03-0.26-0.07-0.4s-0.1-0.25-0.19-0.34
            c-0.08-0.09-0.2-0.14-0.35-0.14c-0.14,0-0.26,0.04-0.34,0.14c-0.08,0.09-0.15,0.21-0.18,0.34c-0.04,0.14-0.06,0.27-0.07,0.4
            s-0.01,0.27-0.01,0.42C605.29,296.58,605.29,296.73,605.3,296.86z"/>
          <path class="st52" d="M609.53,298.31h-0.95l-1.24-3.81h0.87l0.85,2.68h0.01l0.86-2.68h0.86L609.53,298.31z"/>
          <path class="st52" d="M626.81,296.08c0.01,0,0.03,0,0.06,0c0.03,0,0.05,0,0.07,0c0.09,0,0.17-0.01,0.24-0.02
            c0.08-0.02,0.15-0.04,0.21-0.08s0.12-0.08,0.16-0.14c0.04-0.06,0.06-0.14,0.06-0.23c0-0.15-0.05-0.27-0.16-0.36
            s-0.23-0.14-0.37-0.14c-0.18,0-0.32,0.06-0.42,0.18c-0.1,0.12-0.15,0.28-0.15,0.48h-0.72c0.01-0.38,0.14-0.7,0.37-0.93
            c0.23-0.24,0.54-0.36,0.92-0.36c0.15,0,0.3,0.02,0.45,0.07c0.15,0.05,0.28,0.11,0.41,0.2c0.12,0.09,0.22,0.2,0.29,0.33
            s0.11,0.28,0.11,0.44c0,0.18-0.05,0.35-0.14,0.49s-0.22,0.23-0.39,0.28v0.01c0.2,0.05,0.36,0.15,0.48,0.3
            c0.12,0.16,0.18,0.34,0.18,0.55c0,0.19-0.04,0.37-0.11,0.52c-0.07,0.15-0.17,0.28-0.3,0.39c-0.13,0.1-0.28,0.18-0.45,0.24
            c-0.17,0.05-0.34,0.08-0.53,0.08c-0.42,0-0.76-0.12-1.01-0.36c-0.25-0.24-0.38-0.57-0.38-1h0.72c0.01,0.22,0.07,0.39,0.18,0.53
            c0.11,0.14,0.27,0.21,0.48,0.21c0.17,0,0.32-0.05,0.43-0.16c0.12-0.11,0.17-0.25,0.17-0.42c0-0.13-0.03-0.24-0.08-0.31
            s-0.11-0.13-0.19-0.17c-0.08-0.03-0.17-0.06-0.26-0.06c-0.09-0.01-0.21-0.01-0.34-0.01V296.08z"/>
          <path class="st52" d="M628.78,295.52c0.07-0.25,0.17-0.45,0.29-0.6c0.12-0.15,0.27-0.26,0.43-0.33c0.16-0.07,0.34-0.1,0.53-0.1
            c0.2,0,0.38,0.03,0.54,0.1c0.16,0.07,0.31,0.17,0.44,0.33c0.13,0.15,0.22,0.35,0.3,0.6s0.11,0.55,0.11,0.9
            c0,0.36-0.04,0.67-0.11,0.92c-0.07,0.25-0.17,0.46-0.29,0.61c-0.12,0.15-0.27,0.26-0.43,0.33c-0.17,0.07-0.35,0.1-0.54,0.1
            c-0.19,0-0.37-0.03-0.53-0.1c-0.16-0.07-0.31-0.18-0.43-0.33c-0.13-0.15-0.22-0.35-0.29-0.61c-0.07-0.25-0.11-0.56-0.11-0.92
            C628.67,296.07,628.71,295.77,628.78,295.52z M629.44,296.86c0.01,0.13,0.03,0.27,0.07,0.41c0.04,0.14,0.1,0.25,0.18,0.35
            c0.09,0.09,0.2,0.14,0.34,0.14c0.15,0,0.26-0.05,0.35-0.14s0.15-0.21,0.19-0.35c0.04-0.14,0.06-0.28,0.07-0.41
            c0.01-0.13,0.01-0.28,0.01-0.44c0-0.15,0-0.29-0.01-0.42c-0.01-0.13-0.03-0.26-0.07-0.4s-0.1-0.25-0.19-0.34
            c-0.08-0.09-0.2-0.14-0.35-0.14c-0.14,0-0.26,0.04-0.34,0.14c-0.08,0.09-0.15,0.21-0.18,0.34c-0.04,0.14-0.06,0.27-0.07,0.4
            s-0.01,0.27-0.01,0.42C629.43,296.58,629.43,296.73,629.44,296.86z"/>
          <path class="st52" d="M631.74,295.52c0.07-0.25,0.17-0.45,0.29-0.6c0.12-0.15,0.27-0.26,0.43-0.33c0.16-0.07,0.34-0.1,0.53-0.1
            c0.2,0,0.38,0.03,0.54,0.1c0.16,0.07,0.31,0.17,0.44,0.33c0.13,0.15,0.22,0.35,0.3,0.6s0.11,0.55,0.11,0.9
            c0,0.36-0.04,0.67-0.11,0.92c-0.07,0.25-0.17,0.46-0.29,0.61c-0.12,0.15-0.27,0.26-0.43,0.33c-0.17,0.07-0.35,0.1-0.54,0.1
            c-0.19,0-0.37-0.03-0.53-0.1c-0.16-0.07-0.31-0.18-0.43-0.33c-0.13-0.15-0.22-0.35-0.29-0.61c-0.07-0.25-0.11-0.56-0.11-0.92
            C631.64,296.07,631.67,295.77,631.74,295.52z M632.41,296.86c0.01,0.13,0.03,0.27,0.07,0.41c0.04,0.14,0.1,0.25,0.18,0.35
            c0.09,0.09,0.2,0.14,0.34,0.14c0.15,0,0.26-0.05,0.35-0.14s0.15-0.21,0.19-0.35c0.04-0.14,0.06-0.28,0.07-0.41
            c0.01-0.13,0.01-0.28,0.01-0.44c0-0.15,0-0.29-0.01-0.42c-0.01-0.13-0.03-0.26-0.07-0.4s-0.1-0.25-0.19-0.34
            c-0.08-0.09-0.2-0.14-0.35-0.14c-0.14,0-0.26,0.04-0.34,0.14c-0.08,0.09-0.15,0.21-0.18,0.34c-0.04,0.14-0.06,0.27-0.07,0.4
            s-0.01,0.27-0.01,0.42C632.4,296.58,632.4,296.73,632.41,296.86z"/>
          <path class="st52" d="M636.63,298.31h-0.95l-1.24-3.81h0.87l0.85,2.68h0.01l0.86-2.68h0.86L636.63,298.31z"/>
          <path class="st52" d="M645.22,295.78c-0.03-0.19-0.12-0.35-0.28-0.47c-0.16-0.13-0.35-0.19-0.56-0.19
            c-0.18,0-0.34,0.04-0.47,0.11c-0.13,0.07-0.24,0.17-0.32,0.29s-0.14,0.26-0.18,0.42c-0.04,0.16-0.06,0.32-0.06,0.5
            c0,0.17,0.02,0.33,0.06,0.48s0.1,0.29,0.18,0.41c0.08,0.12,0.19,0.22,0.32,0.29s0.29,0.1,0.47,0.1c0.25,0,0.45-0.08,0.6-0.23
            c0.15-0.16,0.24-0.36,0.27-0.62h0.81c-0.02,0.23-0.08,0.45-0.17,0.64s-0.21,0.36-0.35,0.49c-0.15,0.14-0.32,0.24-0.52,0.32
            c-0.2,0.07-0.41,0.11-0.64,0.11c-0.29,0-0.55-0.05-0.78-0.15c-0.23-0.1-0.43-0.24-0.59-0.42s-0.29-0.39-0.37-0.63
            c-0.09-0.24-0.13-0.5-0.13-0.77c0-0.28,0.04-0.54,0.13-0.79c0.08-0.25,0.21-0.46,0.37-0.64c0.16-0.18,0.36-0.33,0.59-0.43
            c0.23-0.1,0.49-0.15,0.78-0.15c0.21,0,0.41,0.03,0.6,0.09c0.19,0.06,0.36,0.15,0.5,0.27c0.15,0.12,0.27,0.26,0.36,0.43
            c0.09,0.17,0.15,0.37,0.18,0.58H645.22z"/>
          <path class="st52" d="M647.67,294.5h0.86l1.43,3.81h-0.87l-0.29-0.85h-1.42l-0.3,0.85h-0.85L647.67,294.5z M647.59,296.83h0.99
            l-0.48-1.4h-0.01L647.59,296.83z"/>
          <path class="st52" d="M650.74,295.2h-1.14v-0.71h3.12v0.71h-1.14v3.11h-0.84V295.2z"/>
          <path class="st52" d="M654.64,294.5h0.84v3.81h-0.84V294.5z"/>
          <path class="st52" d="M656.21,294.5h0.84v3.81h-0.84V294.5z"/>
        </g>
        <g>
          <path class="st52" d="M623.12,299.7h-11.19l5.59-9.69L623.12,299.7z M612.8,299.2h9.46l-4.73-8.19L612.8,299.2z"/>
          <g>
            <path class="st52" d="M617.95,297.96c0,0.1-0.01,0.18-0.02,0.24c-0.01,0.07-0.04,0.12-0.08,0.16
              c-0.04,0.04-0.09,0.07-0.15,0.09c-0.06,0.02-0.14,0.03-0.24,0.03s-0.18-0.01-0.24-0.03c-0.06-0.02-0.12-0.05-0.15-0.09
              c-0.04-0.04-0.06-0.09-0.08-0.16c-0.01-0.07-0.02-0.15-0.02-0.24c0-0.1,0.01-0.18,0.02-0.25c0.02-0.07,0.04-0.12,0.08-0.16
              c0.04-0.04,0.09-0.07,0.15-0.09c0.07-0.02,0.15-0.03,0.24-0.03s0.18,0.01,0.24,0.03c0.06,0.02,0.11,0.05,0.15,0.09
              s0.07,0.1,0.08,0.16C617.94,297.78,617.95,297.86,617.95,297.96z M617.84,296.93c0,0.02-0.01,0.04-0.02,0.06
              s-0.03,0.04-0.06,0.05c-0.03,0.01-0.07,0.02-0.12,0.03c-0.05,0.01-0.11,0.01-0.19,0.01c-0.08,0-0.14,0-0.19-0.01
              c-0.05-0.01-0.09-0.02-0.12-0.03s-0.05-0.03-0.06-0.05s-0.02-0.04-0.02-0.06l-0.09-3.21c0-0.03,0.01-0.06,0.02-0.08
              c0.01-0.02,0.04-0.04,0.08-0.06c0.04-0.02,0.09-0.03,0.15-0.03c0.06-0.01,0.14-0.01,0.23-0.01c0.09,0,0.17,0,0.23,0.01
              c0.06,0.01,0.11,0.02,0.15,0.04c0.04,0.02,0.06,0.03,0.08,0.06c0.02,0.02,0.02,0.05,0.02,0.08L617.84,296.93z"/>
          </g>
        </g>
      </g>
      <g>
        <circle class="st52" cx="594.56" cy="293.73" r="0.58"/>
        <g>
          <path class="st52" d="M594.56,295.34c-0.89,0-1.62-0.72-1.62-1.62s0.72-1.62,1.62-1.62c0.71,0,1.33,0.46,1.54,1.15l-0.24,0.07
            c-0.18-0.58-0.7-0.97-1.3-0.97c-0.75,0-1.37,0.61-1.37,1.37s0.61,1.37,1.37,1.37c0.6,0,1.12-0.39,1.3-0.97l0.24,0.07
            C595.89,294.88,595.27,295.34,594.56,295.34z"/>
        </g>
        <polygon class="st52" points="592.87,299.13 592.69,298.95 594.43,297.26 594.43,295.22 594.68,295.22 594.68,297.36"/>
        <polygon class="st52" points="591,299.14 590.84,298.95 592.9,297.18 596.83,297.18 594.55,299.14 594.39,298.95 596.15,297.43 592.99,297.43"/>
        <rect x="594.68" y="293.6" class="st52" width="2.26" height="0.25"/>
      </g>
    </g>
    <path class="st52" d="M554.2,297.93h-0.25c0-1.08,1.88-1.87,2.87-1.87h30.96v0.25h-30.96C555.93,296.32,554.2,297.05,554.2,297.93
      z"/>
    <path class="st52" d="M694.75,298.01h-0.25c0-0.88-1.73-1.62-2.62-1.62h-30.96v-0.25h30.96
      C692.87,296.14,694.75,296.93,694.75,298.01z"/>
  </g>
  <text transform="matrix(0.95 0 0 1 711.7256 297.8712)" class="st52 st37 st53">PROBE COMP</text>
  <g>
    <text transform="matrix(0.95 0 0 1 665.1863 230.497)" class="st36 st37 st38">Push to</text>
  </g>
  <g>
    <text transform="matrix(1 0 0 1 291.8899 325.4762)" class="st30 st31 st54">Enabling Teaching</text>
  </g>
  <!-- Power Button -->
  <g class="valid" @click="power()">
    <path transform="matrix(1 0 0 1 -305 150)" :class="{'st24': !on, 'on': on}" d="M512.64,164.06h-14.55c-1.37,0-2.49-1.12-2.49-2.49v-8.17c0-1.37,1.12-2.49,2.49-2.49h14.55
      c1.37,0,2.49,1.12,2.49,2.49v8.17C515.13,162.94,514.01,164.06,512.64,164.06z"/>
    <text transform="matrix(1 0 0 1 190 321)" style="font-size: 6px;"> POWER </text>
  </g>
  <!-- JsxGraph in Oscilloscope -->
  <g>
    <foreignObject x="200" y="140" width="250" height="130">
      <jsx-graph :graphid="'osgraph' + number" ref="osgraph" :styling="{width: 250, height: 130, background: ''}"/>
    </foreignObject>
    <!--<text transform="matrix(1 0 0 1 255 260)" class="mode"> Type : {{ info.graph.type }} </text>
    <text transform="matrix(1 0 0 1 240 190)" class="mode"> Period : {{ graphPeriod }} {{ info.graph.unit }}</text>-->
  </g>
  <!-- Display Oscillscope  -->
  <g v-if="on">
    <text class="st55" transform="matrix(1 0 0 1 200 285)"> CH1 : </text>
    <text class="st55" transform="matrix(1 0 0 1 235 285)"> {{ plots[0].freq }}Hz {{ plots[0].type}} </text>
    <text class="st55" transform="matrix(1 0 0 1 305 285)"> CH2 : </text>
    <text class="st55" transform="matrix(1 0 0 1 340 285)"> {{ plots[1].freq }}Hz {{ plots[1].type}} </text>
    <text class="st55" transform="matrix(1 0 0 1 420 285)"> {{ menu.main.toUpperCase() }} </text>
  </g>
  <!-- Menu -->
  <g v-if="menu.show && on">
    <rect x="419" y="136" width="50" height="155" rx="3" ry="3" style="fill:#3b4475"/>
    <text class="st1 st54" transform="matrix(1 0 0 1 430 152)"> MENU </text>
    <g v-if="singlemode" class="menu-text">
      <text class="st1 menu-text" transform="matrix(1 0 0 1 430 172)"> Graph CH </text>
      <text class="st1" style="font-size: 12px;" transform="matrix(1 0 0 1 430 265)"> </text>
      <g class="valid">
        <rect
          :class="{'st1': menu.sub !== 'zoomIn', 'toggle': menu.sub === 'zoomIn'}"
          x="425" y="180" width="40" height="30" rx="5" ry="5"/>
        <text transform="matrix(1 0 0 1 429 199)"> Zoom-In </text>
      </g>
      <g class="valid">
        <rect
          :class="{'st1': menu.sub !== 'zoomOut', 'toggle': menu.sub === 'zoomOut'}"
          x="425" y="215" width="40" height="30" rx="5" ry="5"/>
        <text transform="matrix(1 0 0 1 425 233)"> Zoom-Out </text>
      </g>
    </g>
  </g>
</g>
</template>

<script>
import JsxGraph from '../../../graph/JSXGraph.vue'
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'
import { graph } from '../../../../mixins/graph.js'

const createTimeList = function (n, interval) {
  const arr = Array(n)
  let x = interval
  for (let i = 0; i < n; i++) {
    arr.append(x)
    x += interval
  }
  return arr
}

export default {
  name: 'Oscilloscope',
  props: ['data'],
  mixins: [pins, graph],
  components: { JsxGraph },
  data () {
    return {
      on: false,
      socket: {
        ch1: null,
        ch2: null
      },
      animated: true,
      menu: {
        show: false,
        main: '',
        sub: '',
        single: true // double mode graph is 'false'
      },
      // plots: [{ freq: 100, type: 'sine' }, { freq: 2000, type: 'square' }],
      plots: [{ freq: 0, type: '' }, { freq: 0, type: '' }],
      oschannels: {
        ch1: { xdata: [], ydata: [] },
        ch2: { xdata: [], ydata: [] }
      },
      scale: {
        x: 0.01,
        y: 1.0
      },
      draggables: [],
      g1: null,
      g2: null
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
    window.gsap.set(this.$refs.multi, { transformOrigin: '557px 143px' })
    window.gsap.set(this.$refs.verpos1, { transformOrigin: '571px 211px' })
    window.gsap.set(this.$refs.verpos2, { transformOrigin: '632px 211px' })
    window.gsap.set(this.$refs.verscale1, { transformOrigin: '571px 270px' })
    window.gsap.set(this.$refs.verscale2, { transformOrigin: '632px 270px' })
    window.gsap.set(this.$refs.hopos, { transformOrigin: '681px 214px' })
    window.gsap.set(this.$refs.hoscale, { transformOrigin: '681px 270px' })
    this.draggables.push(this.handleVerticalPos(this.$refs.verpos1, 'ch1'))
    this.draggables.push(this.handleVerticalPos(this.$refs.verpos2, 'ch2'))
    this.draggables.push(this.handleMultipurpos(this.$refs.multi))
    this.draggables.push(this.handleScaleAxis(this.$refs.verscale1, 'vertical'))
    this.draggables.push(this.handleScaleAxis(this.$refs.verscale2, 'vertical'))
    this.draggables.push(this.handleScaleAxis(this.$refs.hoscale, 'horizontal'))
    this.draggables.push(this.handleHorizontalPos(this.$refs.hopos, 'both'))
  },
  beforeDestroy () {
    if (this.board) this.freeBoard()
  },
  computed: {
    zoommode () {
      return this.menu.main === 'zoom'
    },
    singlemode () {
      return this.menu.main === 'single'
    },
    circuitSimulationData () {
      return store.state.sim.result
    },
    circuitInfo () {
      return this.circuitSimulationData.circuitinfo
    },
    graphtype () { // static, period, sensing
      return !this.circuitInfo.type ? '' : this.circuitInfo.type
    },
    currSocket () {
      return this.socket.ch1 ? this.socket.ch1 : this.socket.ch2
    }
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    power () {
      window.event.stopPropagation()
      this.on = !this.on
      if (this.on) {
        // console.log(this.$refs.osgraph.$el)

        this.displayDefaultGraph()
        this.defaultButtonRotation()

        // const svg = document.getElementById('osgraph').getElementsByTagName('svg')[0]
        // // console.log(svg.width, svg.height)
        // svg.setAttribute('width', 250 + 'px')
        // svg.setAttribute('height', 130 + 'px')
      } else {
        if (this.board) this.freeBoard()
        if (this.inter) {
          clearInterval(this.inter)
          this.inter = null
        }
      }
    },
    start (socket) {
      // console.log('OS start ', socket)
      this.on = true
      const codename = socket.url.substring(socket.url.length - 6, socket.url.length - 2)
      const ch = codename.charAt(3) === '1' ? 'ch1' : 'ch2'
      const periodtime = this.circuitInfo['period time']
      const range = (0.001 * periodtime) * this.circuitInfo['sampling count']
      this.initAnimateBoard(this.graphtype, 'osgraph' + this.number,
        { range, ydata: this.oschannels.ch1.ydata }, { range, ydata: this.oschannels.ch2.ydata })
      this.displayGraphFromServer(ch, socket)
    },
    displayStaticGraph (ch1_xdata, ch1_ydata, boundingBox = []) {
      this.on = true
      if (!boundingBox.length){ boundingBox = [ch1_xdata[0], 1, ch1_xdata[ch1_xdata.length - 1], -1] }
      this.initAnimateBoard('static', 'osgraph' + this.number,
      { xdata: ch1_xdata, ydata: ch1_ydata }, { xdata: [], ydata: [] },
      false, boundingBox)
      // console.log("init graph")
      this.board.update()
      if (this.g1) this.board.removeObject(this.g1)
      this.g1 = this.board.create('curve', [ch1_xdata, ch1_ydata],
        { strokeWidth: 2, strokeColor: 'yellow' })
    },
    off () {},
    setMainMenu (menu) {
      this.menu.main = menu
    },
    setSubMenu (menu) {
      this.menu.sub = menu
    },
    displayGraphFromServer (ch, socket) {
      this.socket[ch] = socket
      const interval = 0.01
      const limit = 1 / 0.01
      let x = 0 // periodTime (ms)
      this.oschannels[ch].xdata = []
      this.oschannels[ch].ydata = []

      for (let i = 0; i < limit; i++) {
        this.oschannels[ch].xdata.push(x)
        x += interval
      }

      socket.onmessage = ({ data }) => {
        if (!this.board) return
        data = JSON.parse(data)
        // console.log("OS socket onmessage:", data)
        if (this.circuitInfo.type !== 'static') {
          this.oschannels[ch].xdata = data['time list']
          this.oschannels[ch].ydata = data.value
        } else {
          this.oschannels[ch].xdata = createTimeList(100, 0.01)
          const arr = Array(100).fill(data.value)
          this.oschannels[ch].ydata = arr
        }
        const xsize = this.oschannels[ch].xdata.length
        const boundValue = Math.abs(data.bound_value)
        // console.log("boundValue", boundValue)
        // console.log("time list: ", data['time list'])
        this.board.setBoundingBox([-0.1 * this.oschannels[ch].xdata[xsize - 1], boundValue, this.oschannels[ch].xdata[xsize - 1], -1 * boundValue])
        // this.board.setBoundingBox([-0.1, 5, 1.02, -5])

        this.board.update()
        if (ch === 'ch1') {
          if (this.g1) this.board.removeObject(this.g1)
          this.g1 = this.board.create('curve', [this.oschannels.ch1.xdata, this.oschannels.ch1.ydata],
            { strokeWidth: 2, strokeColor: 'yellow' })
        } else {
          if (this.g2) this.board.removeObject(this.g2)
          this.g2 = this.board.create('curve', [this.oschannels.ch2.xdata, this.oschannels.ch2.ydata],
            { strokeWidth: 2, strokeColor: 'red' })
        }
      }
    },
    displayMenu () {
      window.event.stopPropagation()
      this.menu.show = !this.menu.show
    },
    displayDefaultGraph () {
      if (this.board) this.freeBoard()
      this.setGraphAttribute(true, true, false)
      this.setFunctionGraphData({ freq: 0, type: '' })
      this.initBoard('single', 'osgraph' + this.number)
    },
    updateGraphs () {
      this.drawGraphByType(this.plots[0].type, 'ch1')
      this.drawGraphByType(this.plots[1].type, 'ch2')
    },
    handleTrigger () {
      this.animated = !this.animated
      this.$store.commit('socket/sendMessage', { socket: this.currSocket, message: { trigger: !this.animated } })
    },
    /** *******************************/
    /** ***** Button Spin Animation **/
    /** *****************************/
    handleScaleAxis (dom, orientation) {
      window.event.stopPropagation()
      let curr = 0; let prev = null
      const snapvalue = 60
      const dg = window.Draggable.create(dom, {
        type: 'rotation', // nstead of "x,y" or "top,left", we can simply do "rotation" to make the object spinnable!
        liveSnap: (endValue) => {
          if (Math.round(endValue / snapvalue) !== curr) prev = curr
          curr = Math.round(endValue / snapvalue)
          return curr * snapvalue
        },
        onClick: function (e) {
          e.stopPropagation()
        },
        onPress: function (e) {
          e.stopPropagation()
        },
        onDragStart: function (e) {
          e.stopPropagation()
        },
        onDragEnd: (e) => {
          if (!this.on) return
          if (orientation === 'vertical') {
            const a = curr > prev ? 0.75 : 1.25
            this.scalePositionVertical(a)
          } else if (orientation === 'horizontal') {
            const a = curr > prev ? 0.5 : 2.0
            this.scale.x *= (1 / a)
            this.$store.commit('socket/sendMessage', { socket: this.currSocket, message: { 'x range': a } })
            /* this.oschannels.ch1.xdata = []
            this.oschannels.ch2.xdata = []
            let x = 0
            const limit = Math.round(100 * 1/this.scale.x)
            for (let i = 0; i < limit; i++) {
              this.oschannels.ch1.xdata.push(x)
              this.oschannels.ch2.xdata.push(x)
              x += this.scale.x
            }
            console.log(this.oschannels) */
          }
          /*
            if (a === 0.75) this.scalePositionHorizontal(a)
            else {
              let x = this.oschannels.ch1.xdata[this.oschannels.ch1.xdata.length - 1]
              const temp = [...this.oschannels.ch1.ydata]
              for (let i = 0; i < 50; i++) {
                temp.push(this.oschannels.ch1.ydata[i])
                this.oschannels.ch1.xdata.push(x)
                x += 0.01
              }
              this.oschannels.ch1.ydata = temp
              if (this.g1) this.board.removeObject(this.g1)
              this.g1 = this.board.create('curve', [this.oschannels.ch1.xdata, this.oschannels.ch1.ydata],
                { strokeWidth: 2, strokeColor: 'yellow' })
              this.scalePositionHorizontal(a)
            }
          } else return */
          // this.updateGraphs()
          e.stopPropagation()
        }
      })
      return dg[0]
    },
    handleMultipurpos (dom) {
      window.event.stopPropagation()
      let curr = 0; let prev = null
      const snapvalue = 60
      const dg = window.Draggable.create(dom, {
        type: 'rotation', // nstead of "x,y" or "top,left", we can simply do "rotation" to make the object spinnable!
        liveSnap: (endValue) => {
          if (Math.round(endValue / snapvalue) !== curr) prev = curr
          curr = Math.round(endValue / snapvalue)
          return curr * snapvalue
        },
        onClick: function (e) {
          e.stopPropagation()
        },
        onPress: function (e) {
          e.stopPropagation()
        },
        onDragStart: function (e) {
          e.stopPropagation()
        },
        onDragEnd: (e) => {
          if (!this.on) return
          if (this.menu.main === 'zoom') {
            const a = curr > prev ? 0.75 : 1.25
            this.zoom(a)
          }
          this.updateGraphs()
          e.stopPropagation()
        }
      })
      return dg[0]
    },
    handleVerticalPos (dom, ch) {
      window.event.stopPropagation()
      let curr = 0; let prev = null
      const snapvalue = 60
      const dg = window.Draggable.create(dom, {
        type: 'rotation', // nstead of "x,y" or "top,left", we can simply do "rotation" to make the object spinnable!
        liveSnap: (endValue) => {
          if (Math.round(endValue / snapvalue) !== curr) prev = curr
          curr = Math.round(endValue / snapvalue)
          return curr * snapvalue
        },
        onClick: function (e) {
          e.stopPropagation()
        },
        onPress: function (e) {
          e.stopPropagation()
        },
        onDragStart: function (e) {
          e.stopPropagation()
        },
        onDragEnd: (e) => {
          if (!this.on) return
          const a = curr < prev ? -1 : 1
          this.$store.commit('socket/sendMessage', { socket: this.socket[ch], message: { 'y offset': 0.1 * a } })
          e.stopPropagation()
        }
      })
      return dg[0]
    },
    handleHorizontalPos (dom, ch) {
      window.event.stopPropagation()
      let curr = 0; let prev = null
      const snapvalue = 60
      const dg = window.Draggable.create(dom, {
        type: 'rotation', // nstead of "x,y" or "top,left", we can simply do "rotation" to make the object spinnable!
        liveSnap: (endValue) => {
          if (Math.round(endValue / snapvalue) !== curr) prev = curr
          curr = Math.round(endValue / snapvalue)
          return curr * snapvalue
        },
        onClick: function (e) {
          e.stopPropagation()
        },
        onPress: function (e) {
          e.stopPropagation()
        },
        onDragStart: function (e) {
          e.stopPropagation()
        },
        onDragEnd: (e) => {
          if (!this.on) return
          const a = curr < prev ? -1 : 1
          this.movePositionHorizontal(0.01 * a, ch)
          this.updateGraphs()
          e.stopPropagation()
        }
      })
      return dg[0]
    },
    autoset () {
      window.event.stopPropagation()
      this.menu.main = 'autoset'
      this.scale.x = 0.01
      this.$store.commit('socket/sendMessage', { socket: this.currSocket, message: { autoset: true } })
      this.board.setBoundingBox([-0.1, 5, 1.02, -5])
      this.board.fullUpdate()
      this.defaultButtonRotation()
    },
    defaultButtonRotation () {
      this.draggables.forEach(obj => {
        window.gsap.to(obj.target, 1, { rotation: 0 })
      })
    },
    cursor () {
      window.event.stopPropagation()
      this.menu.main = 'cursor'
    }
  }
}
</script>

<style lang="scss" scoped>
g.selected {
  path.tool-border{
    stroke-width: 2px;
    stroke: #ff6f61;
  }
}
.pin-cover {
    display: block;
    stroke: none;
    fill: white;
    // fill: #887BB0;
}
.pin:hover {
  .pin-cover {
    cursor: pointer;
    stroke-width: 1px;
    stroke: black;
    fill: #ff6f61;
  }
  .disable {
    cursor: not-allowed;
  }
}
.on {
  fill: #ff6f61;
  stroke:#231815;
  stroke-width:0.5;
}
.valid:hover{
  cursor: pointer;
}
.invalid:hover{
  cursor: not-allowed;
}
.valid .light-on {
    fill: #c2ff61;
}
.toggle{fill: #ff6f61;}
.st0{fill:#B5B5B3;}
.st1{fill:#C4C4C3;}
.st2{fill:#14140D;}
.st3{fill:#D6D6D5;}

.st8{fill:#D6D6D5;stroke:#C4C4C3;stroke-width:0.75;stroke-miterlimit:10;}
.st9{fill:#A7A7A6;}
.st10{fill:#8E8E8D;}
.st11{fill:#F29600;}
.st12{fill:#EE95B6;}
.st13{fill:#FBF3A2;}
.st14{fill:url(#SVGID_5_);stroke:#DBDCDC;stroke-width:0.5;stroke-miterlimit:10;}
.st15{fill:#EEEEEF;}
.st16{fill:#816417;stroke:#595757;stroke-miterlimit:10;}
.st17{fill:#3E3A39;}
.st18{fill:#59D2FF;}
.st19{fill:url(#SVGID_6_);stroke:#DBDCDC;stroke-width:0.5;stroke-miterlimit:10;}
.st20{fill:url(#SVGID_7_);stroke:#DBDCDC;stroke-width:0.5;stroke-miterlimit:10;}
.st21{fill:#59D2FF;stroke:#A3A2A3;stroke-width:0.25;stroke-miterlimit:10;}
.st22{fill:#ADABA9;}
.st23{fill:none;stroke:#ADABA9;stroke-width:0.75;stroke-miterlimit:10;}
.st24{fill:#C4C4C3;stroke:#ADABA9;stroke-width:0.75;stroke-miterlimit:10;}
.st25{fill:#231815;}
.st26{font-family:'Helvetica75-Bold';}
.st27{font-size:5.7685px;}
.st28{fill:#FBF3A2;stroke:#A3A2A3;stroke-width:0.25;stroke-miterlimit:10;}
.st29{fill:none;stroke:#ADABA9;stroke-width:0.5;stroke-miterlimit:10;}
.st30{fill:#1B1B11;}
.st31{font-family:'TimesNewRomanPSMT';}
.st32{font-size:11.4562px;}
.st33{fill:#3B1B83;}
.st34{font-family:'TimesNewRomanPS-BoldMT';}
.st35{font-size:8.6992px;}
.st36{fill:#5D5D5A;}
.st37{font-family:'Helvetica-Light';}
.st38{font-size:5px;}
.st39{fill:#6D6D6C;}
.st40{fill:#9A9A96;}
.st41{fill:#FFFFFF;}
.st42{fill:#595757;}
.st43{fill:#9A9A96;stroke:#1B1B11;stroke-width:0.25;stroke-miterlimit:10;}
.st45{fill:#717071;}
.st46{font-size:5.1245px;}
.st47{fill:none;stroke:#3B3B32;stroke-width:0.25;stroke-miterlimit:10;}
.st48{fill:#D6D6D5;stroke:#ADABA9;stroke-width:0.75;stroke-miterlimit:10;}
.st49{fill:#4C4C4C;stroke:#9E9E9F;stroke-width:0.5;stroke-miterlimit:10;}
.st50{fill:#9E9E9F;}
.st51{fill:#383834;stroke:#ADABA9;stroke-width:3;stroke-miterlimit:10;}
.st52{fill:#1B2122;}
.st53{font-size:3.7387px;}
.st54{font-size:10.8608px;}
.st55{font-size:10.5px; fill: yellow;}
.menu-text{font-size: 9px;}
</style>
